import { remplazarPorTildeASinTilde, filter } from "../../helpers/Buscador"
import { types } from "../../types/types"
import { ESTADOS_BANDEJAS_SUSPENSION } from "../../utils/constants"

const initialState = {
    estadosComunicacion: [],
    estadoComunicacionActual: ESTADOS_BANDEJAS_SUSPENSION.PENDIENTES.toString(),
    datosSuspensionEmpresa: null,
    datosSuspensionAfiliados: [],
    solicitudesComunicacion: [],
    mensajesComunicacion: [],
    observacionesEmpresa: [],
    documentacion: [],
    empresaSeleccionada: null,
    itemAuxs: [],
    fechaCargaDesde: null,
    fechaCargaHasta: null,
    fechaUltimaModificacionDesde: null,
    fechaUltimaModificacionHasta: null,

}

export const comunicacionConEmpresasReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.traerEstadosComunicacionSuccess:
            return {
                ...state,
                estadosComunicacion: action.payload,
                loading: false
            }
        case types.traerEstadosComunicacionError:
            return {
                ...state,
                estadosComunicacion: null,
                loading: false
            }
        case types.updateEstadosSolicitudComunicacion:
            return {
                ...state,
                estadoComunicacionActual: action.payload,
                loading: false
            }
        case types.traerDatosSuspensionEmpresaSuccess:
            return {
                ...state,
                datosSuspensionEmpresa: action.payload,
                loading: false
            }
        case types.traerDatosSuspensionEmpresaError:
            return {
                ...state,
                datosSuspensionEmpresa: null,
                loading: false
            }
        case types.traerDatosSuspensionAfiliadosSuccess:
            return {
                ...state,
                datosSuspensionAfiliados: action.payload,
                loading: false
            }
        case types.traerDatosSuspensionAfiliadosError:
            return {
                ...state,
                datosSuspensionAfiliados: null,
                loading: false
            }
        case types.limpiarDatosSuspensionEmpresas:
            return {
                ...state,
                datosSuspensionEmpresa: null,
                loading: false
            }
        case types.traerSolicitudesComunicacionSuccess:
            return {
                ...state,
                solicitudesComunicacion: action.payload,
                itemAuxs: action.payload,
                loading: false
            }
        case types.traerSolicitudesComunicacionError:
            return {
                ...state,
                solicitudesComunicacion: null,
                loading: false
            }
        case types.traerMensajesComunicacionSuccess:
            return {
                ...state,
                mensajesComunicacion: action.payload,
                loading: false
            }
        case types.traerMensajesComunicacionError:
            return {
                ...state,
                mensajesComunicacion: null,
                loading: false
            }
        case types.traerObservacionesEmpresaSuccess:
            return {
                ...state,
                observacionesEmpresa: action.payload,
                loading: false
            }
        case types.traerObservacionesEmpresaError:
            return {
                ...state,
                observacionesEmpresa: null,
                loading: false
            }
        case types.getDocumentacionPorCuitEmpresaSuccess:
            return {
                ...state,
                documentacion: action.payload,
                loading: false
            }
        case types.getDocumentacionPorCuitEmpresaError:
            return {
                ...state,
                documentacion: null,
                loading: false
            }
        case types.seleccionarEmpresaComunicacion:
            return {
                ...state,
                empresaSeleccionada: action.payload,
                loading: false
            }
        case types.desSeleccionarEmpresaComunicacion:
            return {
                ...state,
                empresaSeleccionada: null,
                loading: false
            }
        case types.buscarSolicitudXUsuario:
            state.itemAuxs = state.itemAuxs.filter(n => n.nombreUsuarioMesa !== null);
            var itemsResults = state.itemAuxs.filter(n => filter(remplazarPorTildeASinTilde(n.nombreUsuarioMesa), remplazarPorTildeASinTilde(action.payload)))
            return {
                ...state,
                solicitudesComunicacion: itemsResults
            };
        case types.buscarSolicitudXUsuarioAfiliaciones:
            state.itemAuxs = state.itemAuxs.filter(n => n.nombreUsuario !== null);
            var itemsResultsAfi = state.itemAuxs.filter(n => filter(remplazarPorTildeASinTilde(n.nombreUsuario), remplazarPorTildeASinTilde(action.payload)))
            return {
                ...state,
                solicitudesComunicacion: itemsResultsAfi
            };
        case types.filtrarPorEstadoSemaforo:
            state.itemAuxs = state.itemAuxs.filter(n => n.urgente !== null);
            var itemResults = state.itemAuxs.filter(n => filter(remplazarPorTildeASinTilde(n.urgente.toString()), remplazarPorTildeASinTilde(action.payload)))
            return {
                ...state,
                solicitudesComunicacion: itemResults
            }
        case types.limpiarObservaciones:
            return {
                ...state,
                observacionesEmpresa: null,
                loading: false
            }
        case types.fechaCargaDesdeComunicacion: 
        return{
            ...state, 
            fechaCargaDesde: action.payload,
            loading: false
        }
        case types.fechaCargaHastaComunicacion: 
        return{
            ...state, 
            fechaCargaHasta: action.payload,
            loading: false
        }
        case types.fechaUltimaModificacionDesdeComunicacion: 
        return{
            ...state, 
            fechaUltimaModificacionDesde: action.payload,
            loading: false
        }
        case types.fechaUltimaModificacionHastaComunicacion: 
        return{
            ...state, 
            fechaUltimaModificacionHasta: action.payload,
            loading: false
        }
        default:
            return state;
    }
}